import React, {forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import {EuiFlexGroup,EuiFlexItem, EuiFormRow, EuiFieldText, EuiButton, EuiSpacer, EuiTextColor, EuiTextArea, EuiListGroup,EuiBadge, EuiSwitch, EuiCallOut, EuiFlexGrid} from '@elastic/eui';
import {ComboSociedadesContainer as ComboSociedades} from '../../../components/Combos/Sociedades/container';
import {ComboProyectosContainer as ComboProyectos} from '../../../components/Combos/Proyectos/container';
import {ComboDireccionesNegocioContainer as ComboDirecciones} from '../../../components/Combos/DireccionesNegocio/container';
import {ComboObrasContainer as ComboObras} from '../../../components/Combos/Obras/container';
import SelectorFecha from '../../../../../shared/components/Combos/Fecha';
import moment from "moment";
import { stringToFloat, toDecimalString } from '../../../../../shared/utils/numbers';
import{ CreateFecha, CreateFechaMoment, ToSQL } from '../../../../../shared/utils/fecha';
import SubFuncionesHorasTable from './SubFuncionesHorasTable';
import { AdjuntarComponent } from '../Adjuntos/component';
import { HelpTooltip } from './help';
import { ItemAdjuntoList } from './itemAdjunto';
import { TIPOINIT } from '../../../components/Listas/TiposAdjunto/constants';
import { PanelInfoBloqueoApp } from '../../../components/Layout/PanelInformativoBloqueo';

const msgDesplazado = <p>{`Marcar la casilla si estás desplazado/a a la hora de prestar el servicio. (Se deberá adjuntar documentación justificativa del viaje).`}
  <br/><strong style={{color:'#30abff'}}>{`Billetes de avión, justificativa de hotel..`}</strong></p>

const msgObra = <p>{`Se podrá agregar únicamente obras correspondientes a la sociedad `}<strong style={{color:'#30abff'}}>{`Elecnor Servicios y Poryectos`}</strong></p>

export const FormularioCrearPartes = forwardRef((props, ref) =>{
 
  let {onSave,onClose,user} = props
  const childRef = useRef();
  const codArea = user.codArea;
  const codPais = user.codPais;
  const idDNUser = user.idDN;
  const dni = user.dni;
  const today = moment();
  
  let [idDN, setIdDN] = useState(idDNUser)
  let [sociedad,setSociedad] = useState(undefined)
  let [proyecto,setProyecto] = useState(undefined)
  let [centroObra, setCentroObra] = useState(undefined);
  let [funSubHoras,setFunSubHoras] = useState([])
  let [fechaDesde, setFechaDesde] = useState(today)
  let [fechaHasta, setFechaHasta] = useState(today)
  let [desplazado, setDesplazado] = useState(false)
  let [incSab, setIncSab] = useState(false)
  let [incDom, setIncDom] = useState(false)
  let [observaciones, setObservaciones] = useState("")
  let [adjuntos, setAdjuntos] = useState({})
  const [filesToSave, setFilesToSave] = useState([]);

  const isInvalidRange = useMemo(()=>{
    const mesDesde = fechaDesde.month()+1;
    const mesHasta = fechaHasta.month()+1;

    if(mesDesde<7 && mesHasta > 6)
    {
      return true
    }

    if((mesDesde === 7 || mesDesde === 8) && mesHasta>8){
      return true
    }

    return false

  },[fechaDesde,fechaHasta])

  useEffect(()=>{
    if(moment(fechaHasta).isBefore(fechaDesde)){
      setFechaHasta(fechaDesde)
    }

  },[fechaDesde])


  useEffect(() => {
    const newFiles = [];
    Object.keys(adjuntos).forEach((item, i) => {
      newFiles.push({file:adjuntos[item], tipo: TIPOINIT});
    });
    setFilesToSave([...filesToSave, ...newFiles]);
  }, [adjuntos]);

  const getMaxHoras = useMemo(()=>{
    if(fechaDesde.month()+1 < 7 || fechaDesde.month()+1 > 8){
      if(moment(fechaDesde).isSame(fechaHasta)){
        if(moment(fechaDesde).day()===5){
          return (fechaDesde.year()===2021 && fechaDesde.month()+1 < 7) ? 8 :user.horasViernes;
        }else{
          return (fechaDesde.year()===2021 && fechaDesde.month()+1 < 7) ? 8 : user.horasLunesJueves
        }
      }else{ 

        let days = fechaHasta.diff(fechaDesde, 'days')
        let i = 1;
        let hayViernes = false;
        
        while (i<=days && !hayViernes) {
          let f = moment(fechaDesde).add(i, 'days');
          hayViernes = moment(f).day()===5;
          i+=1;
        }

        if(!hayViernes){
          return user.horasLunesJueves;
        }else{
          return user.horasViernes;
        }
      }
    }else{
      return user.horasLunesJuevesContinuo
    }
  },[fechaDesde,fechaHasta,user])


  const getFunSub = () => funSubHoras.map((d)=> {
    const data = {idFuncion:d.idFuncion, idSubFuncion: d.idSubFuncion, nHoras: d.nHoras, porcentaje: d.porcentaje}
    return data;
  })

  const getData = () =>{
    const _valueObservaciones = document.getElementsByName('observaciones-form')[0].value;
    return {
      dni: dni,  
      codArea: codArea,
      codPais: codPais,
      idSociedad: sociedad[0].value.toString(), 
      funcionesSubFunciones: getFunSub(),
      idProyecto: (proyecto!==undefined && proyecto.length>0) ? proyecto[0].value : undefined, 
      codCentroObra: (centroObra!==undefined && centroObra.length>0) ? centroObra[0].value : undefined, 
      fechaDesde: ToSQL(fechaDesde), 
      fechaHasta: ToSQL(fechaHasta), 
      desplazado: desplazado,
      offShore: null,
      incSab: incSab,
      incDom: incDom,
      observaciones: _valueObservaciones===""?null:_valueObservaciones
    }
  }

  const onSaveData = () =>{
    if(comprobarErrores() && getSizeAdjuntos<=20){
      const newData = getData();
      onSave && onSave(newData,(filesToSave.length>0?filesToSave:undefined))
    }
  }

  useImperativeHandle(
    ref,
    () => ({
        onSaveDataForm(){
          onSaveData()
        }
     })
  )


// Inicio complemento de adjuntos
  const onChangeAdjuntos = (files) => {
    setAdjuntos(files);
  };

  const onChangeTypeAdjunto = (adjunto)=>{
    
    let pos = filesToSave.findIndex((o) => o.file.name === adjunto.file.name);
    let newData = [ ...filesToSave ];
		newData[pos] = adjunto;
    setFilesToSave(newData)
   
  }

  const onRemove = (itemRemove) =>{
    let pos = filesToSave.findIndex((o) => o.name === itemRemove);
    let newData = [ ...filesToSave ];
    newData.splice(pos, 1);
    setFilesToSave([...newData])
  }

const getExtraAction = (o) => {
    return{
        color: 'danger',
        onClick: ()=>onRemove(o.name),
        iconType: 'crossInACircleFilled',
        iconSize: 's',
        alwaysShow: true,
      }
  }

const renderOptions = () =>{
    return filesToSave.map((o)=>{
      return <ItemAdjuntoList item={o} extraAction={getExtraAction} changeType={onChangeTypeAdjunto}/>
    })
  }

const getList = () =>{
    return filesToSave.length>0 ? 
    <>
        <EuiListGroup style={{maxWidth:'100%',maxHeight:'200px',overflow:'auto'}}>
        {renderOptions()}
        </EuiListGroup>
    </>
    :
    <EuiFlexItem grow={false} key="danger">
    <EuiBadge color="danger">Sin datos</EuiBadge>
    </EuiFlexItem> 
}

  const getSizeAdjuntos = useMemo(()=>{
    const tam = filesToSave.length>0 ? filesToSave.map((item, i) => (item.file.size)).reduce((total, size) =>{return total + size;}) : 0
    const kb = (tam / 1024);
    return (kb/1024);
    //return kb>1024 ? `${toDecimalString((kb/1024))} MB` : `${toDecimalString(kb)} KB`
  },[filesToSave])
// Fin complemanto de adjuntos

  const comprobarErrores = () => {
    return !isInvalidRange && !isInvalidSociedad && !isInvalidProyecto && !isInvalidFunSubHoras && !errorHoras && !errorDesplazado;
  }

  const isInvalidSociedad = useMemo(() => sociedad===undefined || sociedad.length===0,[sociedad])
  const isInvalidProyecto = useMemo(() => (proyecto===undefined || proyecto.length===0),[proyecto,user]);//user.tipo!=='Corporacion' && (proyecto===undefined || proyecto.length===0),[proyecto,user])
  const isInvalidFunSubHoras = useMemo(() => funSubHoras.length===0,[funSubHoras])
  const errorHoras = useMemo(()=> funSubHoras.reduce((a, b) => a + (b['nHoras'] || 0), 0) > getMaxHoras,[funSubHoras,getMaxHoras])
  const errorDesplazado = useMemo(() => (desplazado===true && filesToSave.length === 0),[desplazado,filesToSave])

  const isDisabledProyecto = useMemo(()=>!isInvalidSociedad,[sociedad]);//useMemo(()=>(user.tipo==='Corporacion' || (!isInvalidSociedad && user.tipo!=='Corporacion')),[sociedad,user])
  const isDisabledCentroObra = useMemo(()=>(!isInvalidProyecto && (!isInvalidSociedad && sociedad[0].value.toString()==='00007070' )),[proyecto,sociedad,isInvalidSociedad]);

  const isWeekday = (date) => {
    const day = date.day();
    return day !== 0 && day !== 6;
  };

  const isInvalidDay = (date)=>(date!==undefined ? !isWeekday(date) : false)

  const getMaxDate = useMemo(()=> { 
  if(user.fechaBaja!==undefined && user.fechaBaja!==null){
    return CreateFechaMoment(user.fechaBaja).endOf('day')
  }
  if(fechaDesde.month()+1<7){
    return moment(fechaDesde).add(5-fechaDesde.month(), 'months').endOf('month');
  }
  else{
    if(fechaDesde.month()+1<9){
      return moment(fechaDesde).add(7-fechaDesde.month(), 'months').endOf('month');
    }else{
      return moment(fechaDesde).add(13-fechaDesde.month(), 'months').endOf('month');
    }
  }
  },[fechaDesde,user])

  const getMinDate = useMemo(()=> { 
      return moment(fechaDesde)
  },[fechaDesde])

  const panelInfoFechaBaja = useMemo(()=>{
    const {fechaBaja} = user;
    if(fechaBaja!==null){
      const fechaBajaStr = CreateFecha(fechaBaja);
      return(
        <EuiBadge style={{color:'#006BB4'}} color="#e6f0f8" iconType="iInCircle" iconSide="left">
          {<p>{`Debido a que tienes programada una `}<strong>{`Fecha de Baja el día ${fechaBajaStr}`}</strong>{`, no se podrán crear partes a partir de dicha fecha.`}</p>}
        </EuiBadge>
      )
    }
  },[user])
    
  const errorPanel = useMemo(()=>{
    return !comprobarErrores() ? 
    <EuiBadge style={{color:'#BD271E'}} color="#f8e9e9" iconType="cross" iconSide="left">
      {`Faltan campos por rellenar o tienen errores. ${errorDesplazado?'Falta adjuntar un archivo, desplazado/a activado.':''}`}
    </EuiBadge>
    :null
    },[comprobarErrores,errorDesplazado])

    const errorAdjuntosPanel = useMemo(()=>{
    return getSizeAdjuntos > 20 ? 
    <EuiBadge style={{color:'#BD271E'}} color="#f8e9e9" iconType="cross" iconSide="left">
      {`El total de adjuntos no puede sobrepasar los 20 MB de tamaño.`}
    </EuiBadge>
    :null
    },[,getSizeAdjuntos])
    

  const INFO_PANELS = () =>(
    <EuiFlexGroup direction='column' gutterSize='s'>
        <EuiFlexItem><PanelInfoBloqueoApp withClass={false} compress/></EuiFlexItem>
        <EuiFlexItem>{panelInfoFechaBaja}</EuiFlexItem>
        <EuiFlexItem grow={false}>{errorPanel}</EuiFlexItem>
        <EuiFlexItem grow={false}>{errorAdjuntosPanel}</EuiFlexItem>
        <EuiFlexItem>
        </EuiFlexItem>
    </EuiFlexGroup>
  )
  
  const labelObras = useMemo(()=>(<span>{`Obras `}<HelpTooltip message={msgObra} position="top" adjust/></span>))

  const getComboObras = useMemo(()=>{
    const {partesConObra} = user;
    return (partesConObra)  ? <EuiFlexGroup>
                    <EuiFlexItem>
                      <EuiFormRow label={labelObras} fullWidth>
                          <ComboObras fullWidth dependency 
                          isDisabled={!isDisabledCentroObra} idProyecto={!isInvalidProyecto ? proyecto[0].value : undefined} 
                          selectedOptions={centroObra} onChange={value => setCentroObra(value)}/>
                      </EuiFormRow>
                    </EuiFlexItem>
                  </EuiFlexGroup>
            : null
  },[user,proyecto,centroObra,isDisabledCentroObra,isInvalidProyecto,labelObras])

  return (
    <EuiFlexGroup direction='column'>
      <EuiFlexItem grow={false}>{INFO_PANELS()}</EuiFlexItem>
      
      <EuiFlexItem>
        <EuiFlexGroup>
          <EuiFlexItem>
              <EuiFormRow label="Fecha desde" fullWidth isInvalid={isInvalidRange || isInvalidDay(fechaDesde)}>
                <SelectorFecha fullWidth haveBlockDates selected={fechaDesde} filterDate={isWeekday}
                onChange={date => setFechaDesde(date)} isInvalid={isInvalidRange || isInvalidDay(fechaDesde)}/>
              </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem>
              <EuiFormRow label="Fecha Hasta" fullWidth isInvalid={isInvalidRange || isInvalidDay(fechaHasta)}>
                <SelectorFecha  fullWidth haveBlockDates selected={fechaHasta} filterDate={isWeekday}
                onChange={date => setFechaHasta(date)} isInvalid={isInvalidRange || isInvalidDay(fechaHasta)} minDate={getMinDate}  maxDate={getMaxDate}/>
              </EuiFormRow>
            </EuiFlexItem>

            <EuiFlexItem>
                <EuiFormRow fullWidth label="DN/SG (Actual)">
                <ComboDirecciones fullWidth selectedOptions={idDN} isDisabled={true} onChange={value => {setIdDN(value); }} />
                </EuiFormRow>
            </EuiFlexItem>
            <EuiFlexItem grow={false}>
                <EuiFormRow fullWidth label="Desplazado/a" labelAppend={<HelpTooltip message={msgDesplazado}/>}>
                <EuiSwitch fullWidth name="chkDesplazado" showLabel={false} checked={desplazado} onChange={()=>setDesplazado(!desplazado)}/>
                </EuiFormRow>
            </EuiFlexItem>
        </EuiFlexGroup>
        <EuiSpacer size='s'/>
        <EuiFlexGroup>
          <EuiFlexItem style={{maxWidth:'50%'}}>
              <EuiFormRow label="Sociedad" isInvalid={isInvalidSociedad} fullWidth>
                <ComboSociedades fullWidth selectedOptions={sociedad} onChange={value =>{setSociedad(value)}} isInvalid={isInvalidSociedad} user={user.dni} fechaHasta={fechaHasta}/>
              </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem style={{maxWidth:'50%'}}>
              <EuiFormRow label="Proyecto" isInvalid={isInvalidProyecto} fullWidth>
                <ComboProyectos fullWidth dependency 
                isDisabled={isDisabledProyecto ? false : true} idSociedad={!isInvalidSociedad ? sociedad[0].value : undefined} 
                selectedOptions={proyecto} fechaHasta={fechaHasta} onChange={value => setProyecto(value)} isInvalid={isInvalidProyecto}/>
              </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
        <EuiSpacer size='s'/>
        {getComboObras}
        <EuiSpacer size="m" />
        <SubFuncionesHorasTable sociedad={sociedad} funSubHoras={funSubHoras} setFunSubHoras={setFunSubHoras} 
        ref={childRef} dni={dni} codArea={codArea} idDN={idDNUser} maxHoras={getMaxHoras}/>
        <EuiSpacer size="m" />
        <EuiFlexGroup>
          <EuiFlexItem grow={6}>
            <EuiFormRow fullWidth label="Observaciones">
              <EuiTextArea
                  rows={4}
                  fullWidth
                  defaultValue={observaciones}
                  name='observaciones-form'
                  //value={observaciones}
                  //onChange={(e) => setObservaciones(e.target.value)}
                />
            </EuiFormRow>
          </EuiFlexItem>
          <EuiFlexItem grow={6}>
            <EuiFormRow fullWidth label={`Adjuntos`} labelAppend={`Tamaño: ${toDecimalString(getSizeAdjuntos)} MB`}>
            <EuiFlexItem>
                <EuiFlexGroup>
                  <EuiFlexItem>
                    <AdjuntarComponent
                      multiple
                      onChange={onChangeAdjuntos}
                      display={'default'}
                      compressed={true}
                    />
                  </EuiFlexItem> 
                </EuiFlexGroup>
                <EuiFlexGroup>
                  <EuiFlexItem>{getList()}</EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
            </EuiFormRow>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
    </EuiFlexGroup>
  )
})